/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PROHIBITION_OF_FORCED_LABOR',
              'PROHIBITION_OF_BONDED_LABOR',
              'PROHIBITION_OF_INDENTURED_LABOR',
              'PROHIBITION_OF_PRISON_LABOR',
              'PROHIBITION_OF_HUMAN_TRAFFICKING',
              'VOLUNTARY_EMPLOYMENT',
              'VOLUNTARY_OVERTIME',
              'FREEDOM_OF_MOVEMENT',
              'VOLUNTARY_END_OF_EMPLOYMENT',
              'ETHICAL_RECRUITMENT_USE_OF_EMPLOYMENT_AGENCIES_RECRUITERS_AND_O',
              'STATE_IMPOSED_FORCED_LABOR_GOVERNMENT_MANDATED_FORCED_LABOR',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_2: valueSchema,
  },
}
